import ActivityFeedContainer from './containers/ActivityFeedContainer'

export default ActivityFeedContainer
